const speedConfig = {
  speed: 20,
  variance: 0.5,
  spaceDelay: 2,
  commaDelay: 8,
  periodDelay: 10,
  paragraphDelay: 20
};
export default function dynamicTypeSpeed(char) {
  const typingSpeed = speedConfig.speed;
  const variance = speedConfig.variance;
  const varTime = () => typingSpeed * (1 - variance) + Math.floor(Math.random() * typingSpeed * variance * 2);
  switch (char) {
    case ' ':
      return Math.floor(varTime() * speedConfig.spaceDelay);
    case ',':
      return Math.floor(varTime() * speedConfig.commaDelay);
    case '.':
      return Math.floor(varTime() * speedConfig.periodDelay);
    case 'º':
      return Math.floor(varTime() * speedConfig.paragraphDelay);
    default:
      return varTime();
  }
}
//# sourceMappingURL=dynamicTypeSpeed.js.map